import { ViewFactory } from 'wdc-cube-react'
import AnaliseFormScope from '../analise_form.scopes'
import AnaliseFormView from './analise_form.view'

export function registerViews(rv = ViewFactory.register) {
    rv(AnaliseFormScope, AnaliseFormView)
}
